import { IAPUTSave, IRPUTSave } from "./validators";
import { Requests } from "@app/api";

const programContents = {
	save: (data: IAPUTSave): Promise<IRPUTSave> =>
		Requests.send("PUT", "/api/programs/contents/", data, null),
};
export default programContents;
